/** Reads a test selector from a native or component prop bag. */ export function getDataTestId(props) {
    return props?.['data-testid'];
}
